// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"6d8f5aef","766":"d07925de"}[chunkId] + ".chunk.css";
};